export const isMac = () =>
  navigator.platform?.indexOf("Mac") === 0 || navigator.platform === "iPhone";
